import React, { useState, useEffect, Component } from "react";

import DataTable from "react-data-table-component";
import axios from "axios";
import { withRouter } from "react-router";

import { Redirect, Switch, Route, Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { endpoints } from "../../services/apiurl";

// import LinkButton from "../../UI/Input/LinkButton";
import { Card, Button, TextField } from "@mui/material";
// import PageTitle from "../../UI/PageTitle";

import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from "@mui/icons-material/Edit";
import DataTableExtensions from 'react-data-table-component-extensions';
import Pagination, { bootstrap5PaginationPreset } from 'react-responsive-pagination';
import moment from "moment";

// const getItems = (ii) =>
//     Array.from({ length: ii.length }, (v, k) => k).map((k) => ({
//         id: `${ii[k].id}`,
//         name: ii[k].name,
//         full_name: ii[k].full_name,
//         status: `${ii[k].status}`,
//         show_app: `${ii[k].show_app}`,
//         show_web: `${ii[k].show_web}`,
//         content: `item ${k}`,
//     }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

//console.log(localStorage.getItem("user"));

class LoyalityDetail extends Component {

    // Constructor
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            DataisLoaded: false,
            number: 1,
            empty: "",
            currentPage: 1,
            totalPages: 1,
            per_page: 10,
            id: this.props.match.params.id
        };
        // console.log(this.props.match.params.id)

        // this.section_id = this.props.match.params.id;

        // console.log(this.section_id);
    }

    // ComponentDidMount is used to
    // execute the code
    componentDidMount() {
        this.getloyalitynbyid();
    }


    getloyalitynbyid() {
        // const { id } = useParams()
        // console.log('Props:', this.props)
        // console.log(id)
        var id = this.state.id;
        //console.log(id)
        var page = this.state.currentPage;
        var per_page = this.state.per_page;
        axios
            .post(endpoints.getloyalitynbyid, {
                id,
            })
            .then((response) => {
                console.log(response.data.data.length)
                if (response.data.data.length === 0) {
                    this.setState({
                        ...this.state,
                        empty: "Error"
                    })
                } else {
                    this.setState({
                        ...this.state,
                        items: response.data.data,
                        totalPages: response.data.total_pages,
                        local: localStorage.setItem(
                            "data",
                            JSON.stringify(response.data.data)
                        ),
                        DataisLoaded: true,
                    });
                }

                // console.log(response.data.data);
            });

    }


    render() {
        const { DataisLoaded, items, total } = this.state;
        const a = this.state.items

        const links = (this.state.restaurent);
        const test = eval(this.state.items);
        console.log(this.state.items.length)
        for (var i = 0; i < this.state.items.length; i++) {
            const food_item = a[i];
            var food_items = eval(food_item['items'])
            console.log(food_items)
        }

        // const test_a = a;
        // console.log("test_a")
        // if (test_a) {
        //     console.log(eval(test_a['items']));
        //     console.log(this.state.items)
        // }
        // const result = Object.keys(this.state.items.items).map((key) => this.state.items.items[key]);

        // console.log(result);
        const ExpandedComponent = (suppData) => ({ data }) => {
            // const a = JSON.parse(data, null, 2)
            return (
                <>

                    <div className='row px-5'>

                        <div className="col-md-6">
                            <mat-card >
                                <table>
                                    <tr>
                                        <th className='w-50'>Full Name</th>
                                        <td>{data.full_name}</td>
                                    </tr>
                                    <tr>
                                        <th>Bill Number</th>
                                        <td>{data.bill_no}</td>
                                    </tr>
                                    <tr>
                                        <th>Email</th>
                                        <td>{data.email}</td>
                                    </tr>
                                    <tr>
                                        <th>Mobile</th>
                                        <td>{data.mobile}</td>
                                    </tr>
                                    <tr>
                                        <th>Loyality Point</th>
                                        <td>{data.point_earn}</td>
                                    </tr>
                                    <tr>
                                        <th>Resturent Name</th>
                                        <td>{data.name}</td>
                                    </tr>
                                    <tr>
                                        <th>Items</th>
                                        <tr><th>Food Name</th> <th>Quantity</th></tr>
                                        {food_items.map((item) => {
                                            return <tr>

                                                <td>{item.name} </td><td>{item.quantity}</td></tr>;
                                            <tr>
                                                <th>Quality</th>
                                                <td></td></tr>
                                        })}
                                    </tr>
                                    {/* <tr>
                                        <th>Server</th>
                                        <td>{data.server_name}</td>
                                    </tr> */}

                                </table>
                            </mat-card>
                        </div>

                        <div className="col-md-6">
                            <mat-card>
                                <table>
                                    <tr>

                                        <th className='w-75'>Total Amount</th>
                                        <td>{data.total_amount}</td>

                                    </tr>
                                    <tr>
                                        <th>Discount</th>
                                        <td>{data.bill_discount}</td>
                                    </tr>
                                    <tr>
                                        <th>Total Tax</th>
                                        <td>{data.total_tax}</td>
                                    </tr>
                                    <hr></hr>
                                    <tr>
                                        <th>Net Amount</th>
                                        <td>{data.net_amount}</td>
                                    </tr>

                                    <br></br>
                                    <tr>
                                        <th>Create on </th>

                                        <td>{moment(new Date(data.settled_at)).format("DD/MM/YYYY")}</td>
                                    </tr>
                                    <tr>
                                        <th>Server Name</th>
                                        <td>{data.server_name}</td>
                                    </tr>

                                </table>
                            </mat-card>
                        </div>
                    </div>
                    {suppData}{" "}
                </>
            );
        };

        const columns = [
            {

                selector: (row) => row.full_name,
                cellExport: (row) => row.full_name,
                sortable: true
            },
            {

                selector: row => row.email,
                cellExport: (row) => row.email,
                sortable: true
            },
            {
                selector: row => row.mobile,
                cellExport: (row) => row.mobile,
                sortable: true
            },
            {

                selector: row => row.bill_no,
                cellExport: (row) => row.bill_no,
                sortable: true
            },
            {
                selector: row => row.point_earn,
                cellExport: (row) => row.point_earn,
                sortable: true
            },

            {

                // selector: row => row.dob,
                cellExport: (row) => row.name,
                selector: row => row.name,
                // cellExport:(row) =>new Date(row.dob).toLocaleString(),
                omit: true,
                sortable: true

            },
            {

                // selector: row => row.anniversary,
                cellExport: (row) => row.total_amount,
                selector: row => row.total_amount,
                // cellExport:(row) =>new Date(row.anniversary).toLocaleString(),
                omit: true,
                sortable: true
            },
            {

                selector: row => row.bill_discount,
                cellExport: (row) => row.bill_discount,
                omit: true,
                sortable: true
            },
            {


                selector: (row) => row.total_tax,
                cellExport: (row) => row.total_tax,
                omit: true,
                sortable: true
            },
            {

                selector: row => row.net_amount,
                cellExport: (row) => row.net_amount,
                // omit: true,
                sortable: true
            },
            {

                selector: row => row.settled_at,
                cellExport: (row) => row.settled_at,
                omit: true,
                sortable: true
            },

            // {

            //     selector: row => row.create_on,
            //     cellExport: (row) => row.create_on,
            //     sortable: true
            // },
            {

                selector: row => row.server_name,
                cellExport: (row) => row.server_name,
                omit: true,
                sortable: true
            },
            // {
            //     selector: (row) => row.status === 'Status' ? 'Status' : <div>

            //         {/* <select name="status" required className="form-control" onChange={e => removeStatusHandler(row.id, e)} value={this.status}>
            //             <option value={row.status}> {row.status === 1 ? 'Show' : "Hide"}</option>
            //             <option value="1" style={{ ...(row.status === 1 ? { display: 'none' } : {}) }}>Show</option>
            //             <option value="0" style={{ ...(row.status === 0 ? { display: 'none' } : {}) }}>Hide</option>


            //         </select> */}
            //     </div>,
            //     cellExport: (row) => row.status,
            //     sortable: true,

            // },
        ];


        // const sub = async (id, old_status, col_name) => {

        //     if (old_status === '1') {
        //         var status = '0'
        //     }
        //     else {
        //         var status = '1'
        //     }
        //     // alert( id)
        //     axios
        //         .post(endpoints.app_webSecRestStatus, {
        //             id,
        //             status,
        //             col_name
        //         })
        //         .then((response) => {
        //             window.location.reload(true);
        //             this.setState({
        //                 DataisLoaded: true,
        //             });
        //         });
        // }



        // const setCurrentPage = (id) => {
        //     this.state.currentPage = id;
        //     this.fetchData();
        // }

        // const onSelectChange = (per_page) => {
        //     this.state.per_page = per_page;
        //     this.fetchData();
        // }
        const onSubmit = async e => {
            this.filterfetch(e)
            // console.log(e)
        }
        const bFilter = async () => {
            // console.log(this.start_date);
            var end_date = this.end_date
            var start_date = this.start_date
            if (this.rest === undefined) {
                var rest = ''
            }
            else {
                var rest = this.rest
            }

            console.log('working_rest', rest)
            var type = this.type
            var booking_type = this.booking_type


            let a = localStorage.getItem('user')
            let b = JSON.parse(a)
            let user_id = b.id
            let restro_id = b.restro_id

            axios
                .post(endpoints.reservationFilter, {
                    start_date,
                    end_date,
                    rest,
                    type,
                    user_id,
                    restro_id,
                    booking_type

                })
                .then((response) => {
                    // window.location.reload(true);
                    console.log("response", response);
                    this.setState({
                        items: response.data.data,
                        // total: response.data.total,
                        // totalPages:response.data.total_pages,
                        DataisLoaded: true,
                    });
                    console.log(response.data);
                });

        }
        const onStartChange = e => {
            this.start_date = e.target.value

        }
        const onEndChange = e => {
            this.end_date = e.target.value

        }

        const onTypeChange = e => {
            this.type = e.target.value

        }
        const onBookingTypeChange = e => {
            this.booking_type = e.target.value

        }

        const onRestChange = e => {
            this.rest = e.target.value

        }
        const c = [
            {
                full_name: "Name",
                address: "Address ",
                bill_no: "Bill Number",
                addrress: null,
                ambiance: "Ambiance",
                anniversary: "Anniversary",
                create_on: "Created On",
                did_manage_visit: "Manager Visit",
                dining_exp_better: "Dinning Exp.",
                dob: "DOB",
                email: "Email",
                id: 0,
                point_earn: "Loyality Point",
                mobile: "Number",
                music: "Music",
                name: "Resturent Name",
                profession: "Profession",
                qty_of_foodienc: "Qty. Of Food",
                restro_id: 5,
                service: "Service",
                // type: "Restaurant",
                val_for_money: "Val. For Money",
                valuable_feedback: "Feedback",
                what_did_best_like: "Best Like",
                servant_name: 'Servant Name',
                status: 'Status',
                total_amount: 'Total Amount',
                bill_discount: 'Discount',
                total_tax: 'Total Tax',
                net_amount: 'Net Amount',
                settled_at: 'Settled At',
                server_name: 'Server Name'



            }
        ];
        // console.log(a[0]['items'])
        console.log(a.lenght)
        const data = c.concat(a);

        const tableData = {
            columns,
            data,
        };

        console.log(this.state)
        return (
            <div className="App">
                {/* <PageTitle title="Amenities List" linkid={restro_id} linkurl="/dashboard/addamenities" linkTitle="Add Amenities" /> */}
                <Card className="px-3 py-3">

                    {this.state.empty == "" && <DataTableExtensions
                        {...tableData}
                    >
                        <DataTable
                            defaultSortField="id"
                            pagination
                            paginationPerPage={7}
                            paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
                            expandableRows
                            exportHeaders={true}
                            expandableRowsComponent={ExpandedComponent()}
                        />

                    </DataTableExtensions>}
                    {this.state.empty != "" && <p>Data Doesn't Exist</p>}

                </Card>
            </div>
        );

    }
}

export default withRouter(LoyalityDetail);